import React, { useState, useEffect } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";
import OrbViewScene from "../../utils/OrbViewScene";

import "./OrbView.css";

function OrbView(props) {
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const styles = {
    displayStyle: props.unstated.state.shouldDisplayOrbViewScene
      ? "block"
      : "none",
    backgroundColorStyle: isButtonHovered
      ? props.unstated.state.menuColorSecondary
      : "#d1dfec",
  };

  function closeScene() {
    props.unstated.handleShowElement("orbViewScene", false);
  }

  useEffect(() => {
    props.unstated.state.orbViews.length > 0 && OrbViewScene.init();
  }, [props.unstated.state.orbViews.length]);

  return (
    <React.Fragment>
      <canvas id="orb-view-canvas" style={{ display: styles.displayStyle }} />
      <button
        onClick={closeScene}
        onMouseEnter={() => setIsButtonHovered(true)}
        onMouseLeave={() => setIsButtonHovered(false)}
        id="close-orb-view"
        style={{
          display: styles.displayStyle,
          backgroundColor: styles.backgroundColorStyle,
        }}
      >
        X
      </button>
    </React.Fragment>
  );
}

function OrbViewWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <OrbView {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default OrbViewWithUnstated;
